// authDomain must be same-origin as the app for signInWithRedirect to work
// under third-party cookie blocking; Netlify proxies /__/auth/* to the
// corresponding *.firebaseapp.com (see scripts/gen-redirects.js).
// Localhost falls back to the default firebaseapp.com handler.
const isLocal =
    typeof window !== "undefined" &&
    (window.location.hostname === "localhost" ||
        window.location.hostname === "127.0.0.1");

const firebaseConfig = process.env.REACT_APP_ENV === 'dev' ? {
    apiKey: "AIzaSyBbCihMaSG08HJGitr6VJJAd5MBjxAU4yc",
    authDomain: isLocal ? "karirai-dev.firebaseapp.com" : "smartcvbuilderdev.karir.ai",
    projectId: "karirai-dev",
    storageBucket: "karirai-dev.appspot.com",
    messagingSenderId: "934338373927",
    appId: "1:934338373927:web:89450c17cd7bcb087c2102",
    measurementId: "G-CW7FEDC74D"
} : {
    apiKey: "AIzaSyCfWPv9PvB8fgxdes2pMiiDvR8l4EZJJXs",
    authDomain: isLocal ? "karirai-prod.firebaseapp.com" : "cv.karir.ai",
    projectId: "karirai-prod",
    storageBucket: "karirai-prod.appspot.com",
    messagingSenderId: "498302587148",
    appId: "1:498302587148:web:8c7f705e5544fdca15f929",
    measurementId: "G-RFR5VG2B4G"
};;

export default firebaseConfig;